import gql from "graphql-tag"

import {
  CartFields,
  CartUserErrorsFields,
  CustomerUserErrorsFields,
} from "./fragments"

export const CreateCartWithBuyer = gql`
  ${CartFields}
  ${CartUserErrorsFields}
  mutation CreateCartWithBuyer(
    $cartCountry: CountryCode
    $lines: [CartLineInput!]
    $note: String!
    $customerAccessToken: String!
  )
  @inContext(
    country: $cartCountry
    buyer: { customerAccessToken: $customerAccessToken }
  ) {
    cartCreate(input: { lines: $lines, note: $note }) {
      cart {
        ...CartFields
      }
      userErrors {
        ...CartUserErrorsFields
      }
    }
  }
`

export const CreateCart = gql`
  ${CartFields}
  ${CartUserErrorsFields}
  mutation CreateCart(
    $cartCountry: CountryCode
    $lines: [CartLineInput!]
    $note: String!
  ) @inContext(country: $cartCountry) {
    cartCreate(input: { lines: $lines, note: $note }) {
      cart {
        ...CartFields
      }
      userErrors {
        ...CartUserErrorsFields
      }
    }
  }
`

export const AddCartLine = gql`
  ${CartFields}
  ${CartUserErrorsFields}
  mutation AddCartLine(
    $cartId: ID!
    $lines: [CartLineInput!]!
    $cartCountry: CountryCode
  ) @inContext(country: $cartCountry) {
    cartLinesAdd(cartId: $cartId, lines: $lines) {
      cart {
        ...CartFields
      }
      userErrors {
        ...CartUserErrorsFields
      }
    }
  }
`

export const RemoveCartLine = gql`
  ${CartFields}
  ${CartUserErrorsFields}
  mutation RemoveCartLine(
    $cartId: ID!
    $lineIds: [ID!]!
    $cartCountry: CountryCode
  ) @inContext(country: $cartCountry) {
    cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
      cart {
        ...CartFields
      }
      userErrors {
        ...CartUserErrorsFields
      }
    }
  }
`

export const UpdateCartLine = gql`
  ${CartFields}
  ${CartUserErrorsFields}
  mutation UpdateCartLine(
    $cartId: ID!
    $lines: [CartLineUpdateInput!]!
    $cartCountry: CountryCode
  ) @inContext(country: $cartCountry) {
    cartLinesUpdate(cartId: $cartId, lines: $lines) {
      cart {
        ...CartFields
      }
      userErrors {
        ...CartUserErrorsFields
      }
    }
  }
`

export const UpdateCartBuyerIdentity = gql`
  ${CartFields}
  ${CartUserErrorsFields}
  mutation UpdateCartBuyerIdentity(
    $cartId: ID!
    $buyerIdentity: CartBuyerIdentityInput!
    $cartCountry: CountryCode
  ) @inContext(country: $cartCountry) {
    cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $buyerIdentity) {
      cart {
        ...CartFields
      }
      userErrors {
        ...CartUserErrorsFields
      }
    }
  }
`

export const ApplyDiscount = gql`
  ${CartFields}
  ${CartUserErrorsFields}
  mutation ApplyDiscount($cartId: ID!, $discountCode: String!) {
    cartDiscountCodesUpdate(cartId: $cartId, discountCodes: [$discountCode]) {
      cart {
        ...CartFields
      }
      userErrors {
        ...CartUserErrorsFields
      }
    }
  }
`

export const RemoveDiscount = gql`
  ${CartFields}
  ${CartUserErrorsFields}
  mutation RemoveDiscount($cartId: ID!) {
    cartDiscountCodesUpdate(cartId: $cartId, discountCodes: []) {
      cart {
        ...CartFields
      }
      userErrors {
        ...CartUserErrorsFields
      }
    }
  }
`

export const CustomerAddressCreate = gql`
  ${CustomerUserErrorsFields}
  mutation CustomerAddressCreate(
    $customerAccessToken: String!
    $address: MailingAddressInput!
  ) {
    customerAddressCreate(
      customerAccessToken: $customerAccessToken
      address: $address
    ) {
      customerAddress {
        id
      }
      customerUserErrors {
        ...CustomerUserErrorsFields
      }
    }
  }
`

export const CustomerAddressUpdate = gql`
  ${CustomerUserErrorsFields}
  mutation CustomerAddressUpdate(
    $customerAccessToken: String!
    $id: ID!
    $address: MailingAddressInput!
  ) {
    customerAddressUpdate(
      customerAccessToken: $customerAccessToken
      id: $id
      address: $address
    ) {
      customerAddress {
        id
      }
      customerUserErrors {
        ...CustomerUserErrorsFields
      }
    }
  }
`

export const CustomerAddressDelete = gql`
  ${CustomerUserErrorsFields}
  mutation CustomerAddressDelete($id: ID!, $customerAccessToken: String!) {
    customerAddressDelete(id: $id, customerAccessToken: $customerAccessToken) {
      customerUserErrors {
        ...CustomerUserErrorsFields
      }
      deletedCustomerAddressId
    }
  }
`

export const CustomerDefaultAddressUpdate = gql`
  ${CustomerUserErrorsFields}
  mutation CustomerDefaultAddressUpdate(
    $customerAccessToken: String!
    $addressId: ID!
  ) {
    customerDefaultAddressUpdate(
      customerAccessToken: $customerAccessToken
      addressId: $addressId
    ) {
      customer {
        id
      }
      customerUserErrors {
        ...CustomerUserErrorsFields
      }
    }
  }
`
